/**
 * Phone notices in the header capsule, Dynamic-Island style (Julian, 30 Sep 2026).
 * A short, non-error toast ("Link copied", "Chat forked") shows inside the top-left capsule
 * for its usual 4 s instead of the bottom toast. Errors and long texts keep the toast, and
 * so does any screen where the capsule is not on show (desktop, sidebar open, no chat).
 */
/** What fits the capsule on a 375 px phone without cutting ("Link copied", "Chat forked"). */
export const ISLAND_MAX_CHARS = 20;

export function toastGoesToIsland(
  toast: { kind: string; text: string } | null | undefined,
  isPhone: boolean,
  capsuleShown: boolean,
): boolean {
  return !!toast && isPhone && capsuleShown && toast.kind !== "error" && toast.text.length <= ISLAND_MAX_CHARS;
}
